export const TOP_GAINERS_LOSERS = "TOP_GAINERS_LOSERS";
export const TOP_GAINERS_LOSERS_STREAM = "TOP_GAINERS_LOSERS_STREAM";
